import { BookletFromList, BookletList, LinkMetaFromList } from "@/@types/Booklet";
import { Booklet, BookletListResponse, LinkMeta } from "../../booklets/models/BookletListResponse";

export function mapBookletList(response: BookletListResponse): BookletList {
    return {
        data: {
            booklets: response.data.booklets.map((booklet: Booklet): BookletFromList => {
                return {
                    image: booklet.image,
                    title: booklet.title,
                    description: booklet.description,
                    category: booklet.category,
                    order: booklet.order,
                    date: booklet.date,
                    slug: booklet.slug,
                    category_slug: booklet.category_slug,
                };
            })
        },
        links: {
            first: response.links.first,
            last: response.links.last,
            next: response.links.next,
            prev: response.links.prev,
        },
        meta: {
            currentPage: response.meta.current_page,
            from: response.meta.from,
            lastPage: response.meta.last_page,
            links: response.meta.links.map((link: LinkMeta): LinkMetaFromList => ({
                url: link.url,
                label: link.label,
                active: link.active,
            })),
            path: response.meta.path,
            perPage: response.meta.per_page,
            to: response.meta.to,
            total: response.meta.total,
        },
    }
}